

import { object, string, date, number } from 'yup';

export const TableSchema = object({
  numero: number().required('le numero du table est  obligatoire !'),
  nmb_chaise: string().required('numbre des chaises est  obligatoire !'),
  
});
